/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2023-12-29 16:34:21
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2024-01-09 14:43:26
 * @FilePath: /gwm-hippo-h5/hippo-app-h5/src/utils/sensors.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { App } from 'vue'
import sensors from 'sa-sdk-javascript/dist/web/sensorsdata'
import Exposure from 'sa-sdk-javascript/dist/web/plugin/exposure/index.es6'
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js'
import config from './sensorsdata/config'
import { bridge } from '@/utils/bridge'

const install = (app: App<Element>) => {
  let env = 'prod'
  if (import.meta.env.VITE_NODE_ENV !== 'production') {
    env = 'dev'
  }
  const sensorsConfig: {
    serverUrl: string
    platformName: string
  } = config[env][10]

  sensors.use(Exposure, {
    area_rate: 0,
    stay_duration: 0,
    repeated: true,
  })

  sensors.init({
    server_url: sensorsConfig.serverUrl,
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'ajax',
    app_js_bridge: bridge.isApp,
    show_log: import.meta.env.VITE_NODE_ENV !== 'development',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    },
  })

  sensors.registerPage({
    platform_name: sensorsConfig.platformName,
  })

  sensors.quick('autoTrack') // 用于采集 $pageview 事件。
  sensors.use(pageleave, {
    // 用于采集 $WebPageLeave 事件。
    custom_props: {
      prop1: 'value1',
    },
    heartbeat_interval_time: 5,
    max_duration: 5 * 24 * 60 * 60,
    isCollectUrl: function () {
      // url 为要采集页面浏览时长的页面地址。
      return true // 采集
      // return false; // 不采集
    },
  })
  app.config.globalProperties.$sensors = sensors
}

export default {
  install,
  sensors,
}
